export const setShowChat = show => (dispatch, getState) => {
  dispatch({ type: "SET_SHOW_CHAT", payload: show });
};
